import { LocalizedText } from "@/i18n/LocalizedText";
import {
  Boxes,
  ListCollapse,
  LogOut,
  SquareStack,
  SquareTerminal,
} from "lucide-react";
import { BorderLoaderLogo } from "./AnimationLogo";
import RotatingClusters from "./RotatingClusters";
import animatedLogo from "@/assets/animatedLogo.svg";
import { canonicalizeDomain } from "@/utils/domain";
import { FolderSearch, ListChecks, ScanText, UserSearch } from "lucide-react";

const linesCluster = [
  {
    text: "Reading your homepage and navigation",
    icon: <ScanText size={16} />,
  },
  {
    text: "Identifying your core offer and buyers",
    icon: <UserSearch size={16} />,
  },
  {
    text: "Selecting commercial categories to track",
    icon: <ListChecks size={16} />,
  },
  {
    text: "Ranking and pre-selecting the best clusters",
    icon: <FolderSearch size={16} />,
  },
];

const linesPrompts = [
  {
    text: "Mapping clusters to buying categories",
    icon: <SquareStack size={16} />,
  },
  {
    text: "Modeling buyer roles and needs",
    icon: <Boxes size={16} />,
  },
  {
    text: "Generating buyer-style shortlist prompts",
    icon: <SquareTerminal size={16} />,
  },
  {
    text: "Selecting the highest-value prompts",
    icon: <ListCollapse size={16} />,
  },
];

export const ClusterPromptsProcessing = ({
  brand,
  isPrompts,
}: {
  brand: any;
  isPrompts: boolean;
}) => {
  return (
    <div className="w-full max-w-lg flex-col h-full flex items-start justify-start mt-[100px]">
      <div className="relative mb-8">
        <BorderLoaderLogo />
        <img src={animatedLogo}></img>
      </div>
      <div
        className={`absolute top-4 right-4 flex items-center justify-center text-[#d0a197] cursor-not-allowed  px-4 py-2 rounded-full gap-2 text-sm bg-white/20`}
      >
        <LogOut size={16}></LogOut>
        <LocalizedText id="legacy.log.out.mgztlb" />
      </div>

      <p className="text-white text-2xl mb-6 w-full font-medium font-sans">
        {isPrompts
          ? "Creating your prompt set"
          : "Building your topic clusters"}
      </p>
      <div className="text-[#737373] w-full flex flex-col">
        {isPrompts ? (
          <p className="mb-12 text-lg">
            <LocalizedText id="legacy.we.turn.clusters.into.real.questions.buyers.ask.1ruomin" />
          </p>
        ) : (
          <p className="block text-lg items-center flex-wrap leading-[28px] mb-12">
            <span>
              <LocalizedText id="legacy.were.scanning.h4mroo" />
            </span>
            <span className="inline-flex items-baseline mx-1">
              <span className="relative top-[6px] flex w-6 h-6 mr-1 items-center justify-center border rounded-md overflow-hidden">
                <img
                  className="w-full h-full object-cover bg-white"
                  src={`https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://${canonicalizeDomain(brand?.url) || ""}&size=64`}
                  alt="logo"
                />
              </span>
              <span className="text-[#FAFAFA] lowercase">
                {canonicalizeDomain(brand?.url)}
              </span>
            </span>
            <span>
              <LocalizedText id="legacy.to.find.the.categories.buyers.search.for.in.qg1b1g" />
            </span>
          </p>
        )}

        <RotatingClusters
          isPrompts={isPrompts}
          lines={isPrompts ? linesPrompts : linesCluster}
        ></RotatingClusters>
      </div>
    </div>
  );
};
